import { useCallback, useEffect } from 'react';
import { useLazyQuery } from '@grandvisionhq/graphql';
import { useDispatch } from '@grandvisionhq/state';
import '../../../state/actions.js';
import '../../../state/add-to-cart/selectors.js';
import '../../../state/bundles/selectors.js';
import '../../../state/bundles/reducer.js';
import '../../../state/configurator/selectors.js';
import '../../../state/configurator/reducer.js';
import '../../../state/products/selectors.js';
import '../../../state/products/reducer.js';
import { GET_PRESCRIPTION_VALUES_FROM_DOCUMENT } from '../operations/queries/get-prescription-values-from-document.js';
import { mapPrescriptionRecognitionValuesToState } from '../utils/map-prescription-recognition-values-to-state.js';
import { updatePrescriptionRecognitionValues } from '../../../state/configurations/actions.js';

function useGetPrescriptionValues(frameSku) {
    const dispatch = useDispatch();
    const [execute, { data , loading  }] = useLazyQuery(GET_PRESCRIPTION_VALUES_FROM_DOCUMENT);
    const fetchPrescriptionValues = useCallback((storageId, storageToken)=>{
        if (frameSku && storageId && storageToken) {
            execute({
                variables: {
                    prescriptionDocument: {
                        storageId,
                        storageToken
                    }
                },
                // Recognition needs more time to analyze the prescription
                context: {
                    timeout: 2 * 60000
                }
            });
        }
    }, [
        execute,
        frameSku
    ]);
    useEffect(()=>{
        if (frameSku && data) {
            const { prescriptionValues  } = data.getPrescriptionValuesFromDocument;
            if (prescriptionValues) {
                dispatch(updatePrescriptionRecognitionValues({
                    frameSku,
                    left: mapPrescriptionRecognitionValuesToState(prescriptionValues.leftLens),
                    right: mapPrescriptionRecognitionValuesToState(prescriptionValues.rightLens)
                }));
            }
        }
    // @TODO: else if (error)
    }, [
        data,
        dispatch,
        frameSku
    ]);
    return [
        fetchPrescriptionValues,
        loading
    ];
}

export { useGetPrescriptionValues };
//# sourceMappingURL=use-get-prescription-values.js.map
